import React from "react";
import styled from "styled-components";

import { FormattedMessage } from "react-intl";
import { COLORS, TYPE_PRIMARY, TYPE_SECONDARY } from "../ui/Colors";
import { BTN_SMALL, Button, ButtonGroup } from "../form/Button";

const Wrapper = styled.div<{ type: string }>`
    width: 84%;
    font-size: 14px;
    margin: 20px auto 40px auto;
    padding: 20px 15px;
    border: 1px solid ${(p) => COLORS[p.type]["borderColor"]};
    border-radius: 6px;
    background-color: ${(p) => COLORS[p.type]["backgroundColor"]};
    color: ${(p) => COLORS[p.type]["color"]};
    text-align: center;
`;

const Message = styled.div`
    font-size: 18px;
`;

interface ConfirmProps {
    type: string;
    messageId: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export class Confirm extends React.Component<ConfirmProps> {
    onConfirm = () => this.props.onConfirm();

    onCancel = () => this.props.onCancel();

    render() {
        const { type, messageId } = this.props;

        return (
            <Wrapper type={type}>
                <Message>
                    <FormattedMessage id={messageId} />
                </Message>
                <ButtonGroup margin="20px 0 0 0">
                    <Button
                        width={"150px"}
                        type={TYPE_PRIMARY}
                        size={BTN_SMALL}
                        messageId="confirm.yes"
                        onClick={this.onConfirm}
                    />
                    <Button
                        width={"150px"}
                        type={TYPE_SECONDARY}
                        size={BTN_SMALL}
                        messageId="confirm.no"
                        onClick={this.onCancel}
                    />
                </ButtonGroup>
            </Wrapper>
        );
    }
}
